    //JavaScript Document
    import $ from 'jquery';

    window.$ = $;
    window.jQuery = $;


   // sidebar
    $(function () {
        // Dropdown logic
        $(".sidebar-dropdown > a").on('click', function() {
            $(".sidebar-submenu").slideUp(200);
            if ($(this).parent().hasClass("active")) {
                $(".sidebar-dropdown").removeClass("active");
                $(this).parent().removeClass("active");
            } else {
                $(".sidebar-dropdown").removeClass("active");
                $(this).next(".sidebar-submenu").slideDown(200);
                $(this).parent().addClass("active");
            }
        });

        // Open/close sidebar
        $("#close-sidebar").on('click', function() {
            $(".page-wrapper").removeClass("toggled");
        });
        $("#show-sidebar").on('click', function() {
            $(".page-wrapper").addClass("toggled");
        });

        // === RESPONSIVE BEHAVIOR ===
        function autoSidebar() {
            if ($(window).width() <= 1500) {
                // mode mobile
                $(".page-wrapper").removeClass("toggled"); // pastikan tertutup
                $(".sidebar-submenu>ul>li>a").off('click').on('click', function() {
                    $(".page-wrapper").removeClass("toggled");
                });
            } else {
                // mode desktop
                $(".page-wrapper").addClass("toggled"); // tampilkan sidebar lagi
            }
        }

        // Panggil saat load pertama
        autoSidebar();

        // Panggil lagi saat resize
        $(window).on('resize', function() {
            autoSidebar();
        });
    });

    //form
    $(function() {
        $(document).on('click','.btn-add', function(e) {
            e.preventDefault();

            var controlForm = $(".controls form:first"),
                currentEntry = $(this).parents(".entry:first"),
                newEntry = $(currentEntry.clone()).appendTo(controlForm);

            newEntry.find("input").val("");
        })
        .on('click','.btn-remove', function(e) {
            $(this)
                .parents(".entry:first")
                .remove();

            e.preventDefault();
            return false;
        });
    });


    // click row listkk
    $(function ($) {
        $(".clickable-row").on('click', function() {
            window.location = $(this).data("href");
        });
    });


    //modal
    $("#myModal").on("shown.bs.modal", function() {
        $("#myInput").trigger("focus");
    });


    //remove input umurdari&umursampai
    $(document).on('submit', 'form', (e) => {
        $(e.currentTarget).find('input').each((_, el) => {
            if ($(el).val() === '') {
                $(el).remove();
            }
        });
    });

    $("#umurDari").on("change", function() {
        if (this != null && this != "") {
            $("#umurSampai").attr("required", true);
        } else {
            $("#umurSampai").attr("required", false);
        }
    });

    $("#umurSampai").on("change", function() {
        if (this != null && this != "") {
            $("#umurDari").attr("required", true);
        } else {
            $("#umurDari").attr("required", false);
        }
    });


    // Activate tooltip
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    // Select/Deselect checkboxes
    var checkbox = $('table tbody input[type="checkbox"]');
    $("#selectAll").on('click', function() {
        if (this.checked) {
            checkbox.each(function() {
                this.checked = true;
            });
        } else {
            checkbox.each(function() {
                this.checked = false;
            });
        }
    });
    checkbox.on('click', function() {
        if (!this.checked) {
            $("#selectAll").prop("checked", false);
        }
    });


    // Treeview
    $(function ($) {
        let $allPanels = $('.nested').hide();
        let $elements = $('.treeview-animated-element');

        $('.closed').on('click', function () {
        
            // FIX 1: Declare $this with 'let'
            let $this = $(this); 
            let $target = $this.siblings('.nested');
            let $pointer = $this.children('.fa-angle-right');

            $this.toggleClass('open')
            $pointer.toggleClass('down');

            !$target.hasClass('active') ? $target.addClass('active').slideDown() : 
            $target.removeClass('active').slideUp();

            return false;
        });

        $elements.on('click', function () {
        
            // FIX 2 (The one causing the reported error): Declare $this with 'let'
            let $this = $(this); 

            $this.hasClass('opened') ? ($this.removeClass('opened')): ($elements.removeClass('opened'), $this.addClass('opened'));
        })
    });


    //   Filter Search
    $(function() {
        $("#myInput").on("keyup", function() {
            var value = $(this).val().toLowerCase();
            $("#myTable tr").filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
            });
        });
    });


    // Swal Confirm
	window.addEventListener('DOMContentLoaded', function () {

        function confirmAction(selector, title, text, confirmText) {
            $('body').on('click', selector, function (event) {
                event.preventDefault();
                const form = $(this).closest('form');

                Swal.fire({
                    title: title,
                    text: text,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: confirmText,
                }).then((result) => {
                    if (result.isConfirmed) {
                        form.trigger('submit');
                    }
                });
            });
        }

        confirmAction('.show_confirm', 'Apakah Anda yakin?', 'Data akan dihapus!', 'Ya, hapus!');
        confirmAction('.edit_confirm', 'Apakah Anda yakin?', 'Data akan diedit!', 'Ya, edit!');
        confirmAction('.add_confirm', 'Apakah Anda yakin?', 'Data akan ditambah!', 'Ya, tambah!');
    });


    //  Fixed Input Form
    $('input.kesinoman').on('keyup', function(){
        if (
            ($(this).val().length > 0) && ($(this).val().substr(0,9) != 'Kesinoman')
            || ($(this).val() == '')
            ){
            $(this).val('Kesinoman');    
        }
    });

    $('input.dasawisma').on('keyup', function(){
        if (
            ($(this).val().length > 0) && ($(this).val().substr(0,10) != 'Dasa Wisma')
            || ($(this).val() == '')
            ){
            $(this).val('Dasa Wisma');    
        }
    });

    
    // loader-hidden
    window.addEventListener("load" , function() {
        const loader = document.querySelector(".loader");
        if (!loader) return;
        loader.classList.add("loader--hidden");
        loader.addEventListener("transitioned" ,function() {
            document.body.removeChild(loader);
        });
    });
    